import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router} from '@angular/router';

type RewardsTab = { id: string; title: string; link: string };

const TABS: RewardsTab[] = [
  { id: 'rewards', title: 'Rewards/Snacks', link: '/superadmin/rewards/rewards' },
  { id: 'rebates', title: 'CLOs', link: '/superadmin/rewards/rebates' },
  { id: 'brands', title: 'Brands', link: '/superadmin/rewards/brands' },
  { id: 'campaigns', title: 'Campaigns', link: '/superadmin/rewards/campaigns' },
  { id: 'claimed', title: 'Claimed Rewards', link: '/superadmin/rewards/claimed' },
];

@Component({
    selector: 'app-superadmin-rewards',
    templateUrl: './superadmin-rewards.component.html',
    styleUrls: ['./superadmin-rewards.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SuperadminRewardsComponent implements OnInit {
  tabs: RewardsTab[] = TABS;
  activeTab: RewardsTab = TABS[0];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.setActiveTab();
    this.router.events.subscribe(() => this.setActiveTab());
  }

  private setActiveTab(): void {
    const parsedUrl = this.router.parseUrl(this.router.url);
    const url = parsedUrl.toString().split('?')[0];
    this.activeTab = this.tabs.find((tab) => tab.link === url) ?? TABS[0];
  }

  gotoTab(tab: RewardsTab): void {
    if (this.activeTab?.id === tab.id) {
      return;
    }
    this.router.navigate([tab.link]).then();
    this.activeTab = tab;
  }
}
